import {
    Component,
    OnInit,
    ViewChild,
    OnDestroy,
    ChangeDetectorRef,
    ViewRef,
    ElementRef,
} from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { LeaveService } from '../../../leave/services/leave.service';
import { EmployeeService } from '../../../employee/services/employee.service';
import { DoctorService } from '../../../doctor/services/doctor.service';
import { ActuationService } from '../../services/actuation.service';
import { TaskSaveService } from '../../../task/services/task-save.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { EmpresaTreeViewService } from 'app/modules/employee/services/empresa-treeView.service';
import { DiagnosisService } from '../../services/diagnosis.service';
import {
    NoFutureDateValidator,
    requiredValidator,
} from 'app/modules/common/validation/common-validation';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ValidatorFn } from '@angular/forms';
import { LeaveUpdateModel } from 'app/modules/employee-view/entities/LeaveUpdateModel';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DiagnosisCodeComponent } from 'app/modules/common/components/diagnosis-code/diagnosis-code.component';
import { DiagnosisSearchComponent } from 'app/modules/common/components/diagnosis-search/diagnosis-search.component';
import { Observable, of, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import {
    map,
    filter,
    debounceTime,
    distinctUntilChanged,
    switchMap,
} from 'rxjs/operators';
import { EmployeeStoreService } from 'app/modules/employee/services/employee-store.service';
import { MatButton } from '@angular/material/button';
import { LeaveValidatorService } from '../../services/leave-validator.service';
import { ResponseStatus } from 'app/modules/common/enums/common-enums';
import { AddTaskComponent } from 'app/modules/task/components/add-task/add-task.component';

@Component({
    selector: 'app-baja-edit',
    templateUrl: './baja-edit.component.html',
    styleUrls: ['./baja-edit.component.scss'],
    standalone: false
})
export class BajaEditComponent implements OnInit, OnDestroy {
    @ViewChild('updateButton') updateButton: MatButton;
    @ViewChild('diagnosisPickButton') diagnosisPickButton: MatButton;
    @ViewChild('medicoSelect')doctorSearchInput :ElementRef
    _medicoList :any=[];
    public DateOfLeave: string;
    public FullName: string;
    public StandardEstimatedTime: number;
    public IsWoman: boolean;
    public IsSaving: boolean;
    public SaveDisabled = false;
    public FPADisabled = false;
    public LeaveFrom: UntypedFormGroup;
    public Medico: any = [];
    public LeaveTypes: Array<{ value: string; viewValue: string }>;
    public Actitud: Array<{ value: string; viewValue: string }>;
    public Justificada: Array<{ value: string; viewValue: string }>;
    public RiesgoPsicosocial: Array<{ value: string; viewValue: string }>;
    public LeaveComapnyId?: number;
    public CompanyDiagnosisType: string;

    public InvalidDiagnosisCode: boolean;
    public DiagCodValidated: boolean;
    public DiagCodeValidating: boolean;
    public DiagCodeTypeAhed$: Observable<any>;
    public snackBarRef;

    private leaveWasClosed = false;

    public LoadLeaveDetailSubcription: Subscription;

    constructor(
        public dialogRef: MatDialogRef<BajaEditComponent>,
        public dialogDiagnosisRef: MatDialogRef<DiagnosisCodeComponent>,
        public leaveService: LeaveService,
        public employeeService: EmployeeService,
        public doctorService: DoctorService,
        public actionService: ActuationService,
        public empresaService: EmpresaTreeViewService,
        public fb: UntypedFormBuilder,
        public snackBar: MatSnackBar,
        public dialog: MatDialog,
        public diagnosisService: DiagnosisService,
        public sharedService: SharedService,
        public taskService: TaskSaveService,
        public employeeStoreService: EmployeeStoreService,
        public changeDetectionRef: ChangeDetectorRef,
        private leaveValidatorService: LeaveValidatorService
    ) {}

    ngOnDestroy(): void {
        this.LoadLeaveDetailSubcription.unsubscribe();
    }
    
    SearchDoctors()
    {
      const searchInput=this.doctorSearchInput.nativeElement.value ?
        this.doctorSearchInput.nativeElement.value.toLowerCase():'';
  
      this._medicoList =this.Medico.filter(m=>{
        if(m.viewValue!=null)
        {
            const viewValue : string=m.viewValue.toLowerCase();
            return viewValue.indexOf(searchInput) > -1;
        }
      })
    }

    ngOnInit(): void {
        this.InitializeForm();
        this.LoadLeaveTypes();
        this.LoadActitud();
        this.LoadJustificada();
        this.LoadRiesgoPsicosocial();
        this.LoadMedico();
        // These values should keep in shared service in furture.
        const emplooyeeId = localStorage.getItem('EmplooyeeID');
        this.employeeService.GetTrabajador(Number(emplooyeeId)).subscribe(
            (res) => {
                const result = res.result;
                this.IsWoman = result.sexo === 'MUJER' ? true : false;
                this.FullName = this.employeeService.GetFullName(result);
            },
            (err) => {
                console.error(err);
            }
        );

        this.leaveValidatorService.leaveListUpdated.subscribe(() => {
            this.LeaveFrom.get('dischargeDate').updateValueAndValidity();
        });
        
        this.LoadLeaveDetailSubcription = this.LoadLeaveDetails().subscribe(
            (_) => {
                this.empresaService.getEmpresa(this.LeaveComapnyId).subscribe(
                    (resp) => {
                        this.CompanyDiagnosisType = resp.result.tipoDiagnostico;
                    },
                    (err) => {
                        console.error('Error getting Empressa');
                    }
                );
                this.EventListener();
            },
            (err) => {
                console.error('Error Loading LeaveDetails');
            }
        );

        this.DiagCodeTypeAhed$.subscribe((resp) => {
            if (resp.result !== null) {
                this.DiagCodValidated = true;
                this.InvalidDiagnosisCode = false;
                this.LeaveFrom.get('diagDesc').patchValue(
                    resp.result.diagnosisDescription
                );
                this.StandardEstimatedTime = resp.result.standardEstimatedTime;
                this.LeaveFrom.get('diagGroup').patchValue(
                    resp.result.diagnosisGroupId
                );
                this.LeaveFrom.get('diagType').patchValue(
                    resp.result.diagnosisType
                );
            } else {
                this.DiagCodValidated = false;
                this.InvalidDiagnosisCode = true;
                this.LeaveFrom.get('diagDesc').patchValue('');
                this.StandardEstimatedTime = undefined;
                this.LeaveFrom.get('diagGroup').patchValue('');
                this.LeaveFrom.get('diagType').patchValue('');
            }
            this.DiagCodeValidating = false;
        });
    }

    public disableDischargeDateValidationTemporarily(): void {
        this.LeaveFrom.get('dischargeDate').clearValidators(); 
        this.LeaveFrom.get('dischargeDate').updateValueAndValidity(); 
    }

    public enableDischargeDateValidation(): void {
        this.LeaveFrom.get('dischargeDate').setValidators([
            this.leaveValidatorService.leaveDateAndExpectedDischargedDateValidation(),
            Validators.required
        ]);
        this.LeaveFrom.get('dischargeDate').updateValueAndValidity();
    }

    public Cancel(): void {
        this.disableDischargeDateValidationTemporarily(); 
        if (this.snackBarRef !== undefined) {
            this.snackBarRef.dismiss();
        }
        this.dialogRef.close();
        this.LeaveFrom.reset();
    }

    public UpdateLeave(): void {
        if (
            this.LeaveFrom.valid &&
            (this.DiagCodValidated === undefined ||
                this.DiagCodValidated === true)
        ) {
            this.LeaveFrom.updateValueAndValidity({
                onlySelf: false,
                emitEvent: true,
            });
            Object.keys(this.LeaveFrom.controls).forEach((field) => {
                this.LeaveFrom.get(field).updateValueAndValidity();
            });

            this.IsSaving = true;
            const updateModel = this.WrappedToUpdateModel();

            // if was leave was previously closed and not now, then open task panel to create a task
            if (
                this.leaveWasClosed &&
                (this.LeaveFrom.get('dischargeDate').value === null ||
                    this.LeaveFrom.get('dischargeDate').value === '')
            ) {
                const leaveId = this.LeaveFrom.get('leaveId').value;

                const dialogRef = this.dialog.open(AddTaskComponent, {
                    width: '400px',
                    data: leaveId,
                });

                this.sharedService.ShowSnackBar(
                    'Al quitar la fecha de alta, se tiene que crear almenos una tarea'
                );

                dialogRef.afterClosed().subscribe((taskCreated: boolean) => {
                    if (taskCreated) this.updateLeave(updateModel);
                    else this.IsSaving = false;
                });
            } else {
                this.updateLeave(updateModel);
            }
        }
    }

    private updateLeave(updateModel: LeaveUpdateModel) {
        this.leaveService.UpdateLeave(updateModel).subscribe(
            (resp) => {
                if (resp.code === ResponseStatus.Success) {
                    this.snackBarRef = this.sharedService.ShowSnackBar(
                        'Actualizado con éxito'
                    );

                    this.actionService.PublishActuations(updateModel.BajaId);
                    const emplooyeeId = localStorage.getItem('EmplooyeeID');
                    this.leaveService.PublishEmployeeLeaveDetails(
                        updateModel.BajaId,
                        Number(emplooyeeId)
                    );
                    this.leaveService.PublishLeaves(Number(emplooyeeId));
                    this.taskService.PublishTasks(updateModel.BajaId);
                    this.Cancel();
                } else {
                    this.snackBarRef = this.sharedService.ShowSnackBar(
                        'No se pudo actualizar'
                    );
                }

                this.IsSaving = false;
            },
            (err) => {
                console.error(err);
            }
        );
    }

    public OnDischargeDateSelect(
        type: string,
        event: MatDatepickerInputEvent<Date>
    ): void {}

    public SetLeaveRef(leaveRef: string): void {
        this.LeaveFrom.get('leaveRef').setValue(leaveRef); 
      }

    private WrappedToUpdateModel(): LeaveUpdateModel {
        const updateModel = new LeaveUpdateModel();
        updateModel.BajaId = this.LeaveFrom.get('leaveId').value;
        updateModel.Fbaja = DateHelper.getUTCDateString(
            DateHelper.getNativeDate(this.LeaveFrom.get('leaveDate').value)
        );

        updateModel.Falta =
            this.LeaveFrom.get('dischargeDate').value === null
                ? null
                : DateHelper.getUTCDateString(
                      DateHelper.getNativeDate(
                          this.LeaveFrom.get('dischargeDate').value
                      )
                  );

        updateModel.AvisoBaja =
            this.LeaveFrom.get('leaveCommunication').value === null
                ? null
                : DateHelper.getUTCDateString(
                      DateHelper.getNativeDate(
                          this.LeaveFrom.get('leaveCommunication').value
                      )
                  );

        updateModel.AvisoAlta =
            this.LeaveFrom.get('dischargeCommunication').value === null
                ? null
                : DateHelper.getUTCDateString(
                      DateHelper.getNativeDate(
                          this.LeaveFrom.get('dischargeCommunication').value
                      )
                  );

        updateModel.Recaida = this.LeaveFrom.get('relapse').value ? 'S' : 'N';
        updateModel.leaveRef = this.LeaveFrom.get('leaveRef').value === '' ? null : this.LeaveFrom.get('leaveRef').value; 
        updateModel.CodDiagnostico = this.LeaveFrom.get('diagCode').value === '' ? null : this.LeaveFrom.get('diagCode').value;
        updateModel.Diagnostico = this.LeaveFrom.get('diagDesc').value === '' ? null : this.LeaveFrom.get('diagDesc').value;
        updateModel.TipoDiagnostico = this.LeaveFrom.get('diagType').value === '' ? null : this.LeaveFrom.get('diagType').value;
        updateModel.GrupoDiagnostico = this.LeaveFrom.get('diagGroup').value === '' ? null : this.LeaveFrom.get('diagGroup').value;
        updateModel.Agudo = this.LeaveFrom.get('acute').value ? 'S' : 'N';
        updateModel.Cronico = this.LeaveFrom.get('chronical').value ? 'S' : 'N';
        updateModel.Cirujia = this.LeaveFrom.get('surgery').value ? 'S' : 'N';
        updateModel.Embarazada = this.LeaveFrom.get('pregned').value
            ? 'S'
            : 'N';

        updateModel.Fpa =
            this.LeaveFrom.get('expectedDischargeDate').value === null
                ? null
                : DateHelper.getUTCDateString(
                      DateHelper.getNativeDate(
                          this.LeaveFrom.get('expectedDischargeDate').value
                      )
                  );

        updateModel.RiesgosPsicosociales =
            this.LeaveFrom.get('psychoSocialRisk').value;
        updateModel.Justificada = this.LeaveFrom.get('justified').value;
        updateModel.Actitud = this.LeaveFrom.get('attitude').value;
        updateModel.MedicoId = this.LeaveFrom.get('medicoId').value;
        return updateModel;
    }

    private InitializeForm(): void {
        this.leaveValidatorService.validationForm = null;
        this.LeaveFrom = this.fb.group(
            {
                leaveId: ['', Validators.required],
                leaveDate: [
                    null,
                    [
                        requiredValidator(),
                        NoFutureDateValidator(),
                        this.leaveValidatorService.sameLeaveDateEditValidation(),
                        this.leaveValidatorService.isLeaveDateAfterLastDischargeValidation(),
                    ],
                ],
                dischargeDate: [
                    { value: null, disabled: this.FPADisabled },
                    [
                        NoFutureDateValidator(),

                        this.leaveValidatorService.leaveDateAndDischargedDateValidation(),
                        this.leaveValidatorService.hasOpenLeaveValidation(),
                    ],
                ],
                leaveCommunication: [null, [NoFutureDateValidator()]],
                dischargeCommunication: [null, [NoFutureDateValidator()]],
                relapse: [''],
                diagCode: [null],
                diagDesc: [{ value: null, disabled: true }],
                diagType: [''],
                diagGroup: [''],
                standardEstimationTime: [''],
                acute: [''],
                chronical: [''],
                surgery: [''],
                pregned: [''],
                expectedDischargeDate: [
                    null,
                    this.leaveValidatorService.leaveDateAndExpectedDischargedDateValidation(),
                ],
                psychoSocialRisk: [null],
                justified: [''],
                attitude: [''],
                medicoId: [''],
                leaveRef: [''],
            },
            {
                validators: [
                    this.leaveValidatorService.dischargedCommunicationDateAndDischargedDateValidation(),
                    this.leaveValidatorService.leaveDateAndCommunicationDateValidation(),
                ],
            }
        );
        this.leaveValidatorService.validationForm = this.LeaveFrom;
    }

    private LoadLeaveDetails(): Observable<any> {
        const employeeId = localStorage.getItem('EmplooyeeID');
        this.leaveValidatorService.updateLeaveList(Number(employeeId));
        return this.leaveService.SubscribeEmployeeLeaveDetails().pipe(
            tap((resp) => {
                // store if leave is closed
                this.leaveWasClosed = resp.result.fAlta !== null;

                this.LeaveFrom.setValue({
                    leaveId: resp.result.id,
                    leaveDate:
                        resp.result.fBaja !== null
                            ? DateHelper.getMomentDate(resp.result.fBaja)
                            : null,
                    dischargeDate:
                        resp.result.fAlta !== null
                            ? DateHelper.getMomentDate(resp.result.fAlta)
                            : null,
                    leaveCommunication:
                        resp.result.avisoBaja !== null
                            ? DateHelper.getMomentDate(resp.result.avisoBaja)
                            : null,
                    dischargeCommunication:
                        resp.result.avisoAlta !== null
                            ? DateHelper.getMomentDate(resp.result.avisoAlta)
                            : null,
                    relapse: resp.result.recaida === 'S' ? true : false,
                    diagCode:
                        resp.result.codDiagnostico === null
                            ? ''
                            : resp.result.codDiagnostico,
                    diagDesc:
                        resp.result.diagnostico === null
                            ? ''
                            : resp.result.diagnostico,
                    diagType:
                        resp.result.tipoDiagnostico === null
                            ? ''
                            : resp.result.tipoDiagnostico,
                    diagGroup:
                        resp.result.grupoDiagnostico === null
                            ? ''
                            : resp.result.grupoDiagnostico,
                    standardEstimationTime: ``,
                    acute: resp.result.agudo === 'S' ? true : false,
                    chronical: resp.result.cronico === 'S' ? true : false,
                    surgery: resp.result.cirujia === 'S' ? true : false,
                    pregned: resp.result.embarazada === 'S' ? true : false,
                    expectedDischargeDate:
                        resp.result.fpa !== null
                            ? DateHelper.getMomentDate(resp.result.fpa)
                            : null,
                    psychoSocialRisk:
                        resp.result.riesgosPsicosociales === 'X'
                            ? null
                            : resp.result.riesgosPsicosociales,
                    justified:
                        resp.result.justificada === 'X'
                            ? null
                            : resp.result.justificada,
                    attitude: resp.result.actitud,
                    medicoId: resp.result.medicoId,
                    leaveRef : resp.result.referencia,
                });

                this.LeaveComapnyId = resp.result.empresaId;
                this.DateOfLeave = DateHelper.getMomentDate(
                    resp.result.fBaja
                ).format('DD/MM/YYYY');

              /*   if (
                    resp.result.diagnostico &&
                    resp.result.diagnostico !== null &&
                    resp.result.diagnostico !== ''
                ) {
                    this.LeaveFrom.get('diagCode').setValidators(
                        requiredValidator()
                    );
                }
 */
                if (
                    resp.result.fpa &&
                    resp.result.fpa !== null &&
                    resp.result.fpa !== ''
                ) {
                    this.LeaveFrom.get('expectedDischargeDate').setValidators([
                        //requiredValidator(),
                        this.leaveValidatorService.leaveDateAndExpectedDischargedDateValidation(),
                    ]);
                }else{
                    this.LeaveFrom.get('expectedDischargeDate').clearValidators();
                }

                if (
                    resp.result.medicoId &&
                    resp.result.medicoId !== null &&
                    resp.result.medicoId !== 0
                ) {
                    this.LeaveFrom.get('medicoId').setValidators(
                        Validators.required
                    );
                }

                if (
                    resp.result.tipoDiagnostico &&
                    resp.result.tipoDiagnostico === 'CIE9'
                ) {
                    if (
                        resp.result.codDiagnostico &&
                        resp.result.codDiagnostico != null &&
                        Number(resp.result.codDiagnostico) >= 630 &&
                        Number(resp.result.codDiagnostico) <= 677.9 &&
                        !(Number(resp.result.codDiagnostico) >= 634 && Number(resp.result.codDiagnostico) <= 639.9)
                    ) {
                        this.IsWoman = true;
                        this.LeaveFrom.get('pregned').patchValue(true);
                    }
                } else {
                    if (
                        resp.result.codDiagnostico &&
                        resp.result.codDiagnostico != null &&
                        resp.result.codDiagnostico.substring(0, 1) === 'O' &&
                        !(resp.result.codDiagnostico >= 'O00' && resp.result.codDiagnostico <= 'O08.9' 
                        )
                    ) {
                        this.IsWoman = true;
                        this.LeaveFrom.get('pregned').patchValue(true);
                    }
                }
            this.LeaveFrom.get('dischargeDate').updateValueAndValidity();
            })
        );
    }

    private LoadLeaveTypes(): void {
        this.leaveService
            .GetLeaveTypes()
            .pipe(
                map((resp) => {
                    return resp.result.sort().map((element) => {
                        return {
                            value: element.value,
                            viewValue: element.label,
                        };
                    });
                })
            )
            .subscribe(
                (result) => {
                    result.sort(
                        (
                            a: { value: string; viewValue: string },
                            b: { value: string; viewValue: string }
                        ) => {
                            return a.viewValue.localeCompare(b.viewValue);
                        }
                    );
                    this.LeaveTypes = result;
                },
                (err) => {
                    console.error(err);
                }
            );
    }

    private LoadMedico(): void {
        this.doctorService.GetActiveDoctorsDropdown().subscribe((res) => {
            this.Medico = res;
            this._medicoList = res;
        });
    }

    private LoadActitud(): void {
        this.Actitud = [
            { value: 'CORRECTA', viewValue: 'Correcta' },
            { value: 'NEGATIVA', viewValue: 'Negativa' },
            { value: 'POSITIVA', viewValue: 'Positiva' },
        ];
    }

    private LoadJustificada(): void {
        this.Justificada = [
            { value: 'S', viewValue: 'Justificada' },
            { value: 'A', viewValue: 'Justificada con alerta' },
            { value: 'N', viewValue: 'No Justificada' },
        ];
    }

    private LoadRiesgoPsicosocial(): void {
        this.RiesgoPsicosocial = [
            {
                value: 'ENTORNO EXTRALABORAL',
                viewValue: 'Entorno Extralaboral',
            },
            { value: 'ENTORNO LABORAL', viewValue: 'Entorno Laboral' },
            { value: 'NO', viewValue: 'No' },
        ];
    }

    public OnDiagnosisPick(): void {
        this.empresaService.getEmpresa(this.LeaveComapnyId).subscribe(
            (resp) => {
                const diagnoisiPickRef = this.dialog.open(
                    DiagnosisSearchComponent,
                    {
                        width: '600px',
                        data: { Tipo: resp.result.tipoDiagnostico },
                    }
                );
                diagnoisiPickRef.afterClosed().subscribe((result) => {
                    if (result) {
                        this.LeaveFrom.get('diagCode').patchValue(
                            result.diagnosisCode
                        );
                        this.LeaveFrom.get('diagDesc').patchValue(
                            result.diagnosis
                        );
                        this.LeaveFrom.get('diagGroup').patchValue(
                            result.diagnosisGroupId
                        );
                        this.LeaveFrom.get('diagType').patchValue(
                            result.diagnosisType
                        );
                        this.StandardEstimatedTime = result.te;
                    }
                });
            },
            (error) => {
                console.error(error);
            }
        );
    }

    public EventListener(): void {
        this.DiagCodeTypeAhed$ = this.LeaveFrom.get(
            'diagCode'
        ).valueChanges.pipe(
            filter((text) => {
                return text !== null && text.trim().length > 2;
            }),
            debounceTime(300),
            distinctUntilChanged(),
            tap((_) => {
                this.DiagCodeValidating = true;
                this.DiagCodValidated = false;
                this.InvalidDiagnosisCode = false;
            }),
            switchMap((searhText: string) => {

                if(!searhText.trim()){
                    this.LeaveFrom.get('diagDesc').patchValue('');
                    this.LeaveFrom.get('diagGroup').patchValue('');
                    this.StandardEstimatedTime = undefined;
                    return of(null);
                }
                return this.diagnosisService.ValidateDiagnosis(
                    this.CompanyDiagnosisType,
                    searhText
                );
            }),
            tap((result) =>{
                if(result) {
                    this.LeaveFrom.get('diagDesc').patchValue(result.diagnosis);
                    this.LeaveFrom.get('diagGroup').patchValue(result.diagnosisGroupId);
                    this.StandardEstimatedTime = result.te;
                }
            })
        );
        this.LeaveFrom.get('diagCode').valueChanges.subscribe((values) => {
            if(!values){
                this.LeaveFrom.get('diagDesc').patchValue('');
                this.LeaveFrom.get('diagGroup').patchValue('');
                this.StandardEstimatedTime = undefined;
            }
        })
    }
}
